import { Box, Typography } from "@material-ui/core"
import { Divider } from "@mui/material"
import React from "react"
import "../MobilePreview.scss"

const Details = ({ menuPreview }) => {
  const validItems = menuPreview?.data_to_display?.filter((item) => {
    if (typeof item?.value === "number") return true

    if (typeof item?.value === "string" && item?.value.trim() !== "") return true

    if (Array.isArray(item?.value)) {
      if (
        item?.value.length === 1 &&
        (item?.value[0]?.name === "" || item?.value[0]?.name?.trim() === "")
      ) {
        return false
      }

      return item?.value.some(
        (val) =>
          (typeof val === "string" && val.trim() !== "") ||
          typeof val === "number" ||
          (val?.name && val?.name.trim() !== "") ||
          (val?.fact && val?.fact.trim() !== "") ||
          (val?.measurement && val?.measurement.trim() !== "")
      )
    }

    return false
  })

  return (
    <div>
      <Box className="mobile-preview__ingredients">
        <Typography variant="h2" align="center" className="mobile-preview__ingredients-title">
          Details
        </Typography>

        {validItems?.map((item, index) => (
          <div key={index}>
            <Typography variant="body2" className="mobile-preview__ingredient-category">
              {item?.filedName}
            </Typography>

            {item?.show_bullets ? (
              <ul style={{ marginLeft: 20, marginTop: 5, padding: 0 }}>
                {Array.isArray(item?.value) ? (
                  item?.value
                    .filter(
                      (val) =>
                        (typeof val === "string" && val.trim() !== "") ||
                        typeof val === "number" ||
                        (val?.fact && val?.fact.trim() !== "") ||
                        (val?.name && val?.name.trim() !== "") ||
                        (val?.measurement && val?.measurement.trim() !== "")
                    )
                    .map((val, i) => {
                      const displayText =
                        typeof val === "string"
                          ? val
                          : typeof val === "number"
                          ? val
                          : val?.fact || val?.name || val?.measurement || ""

                      return (
                        <li key={i}>
                          <Typography className="mobile-preview__ingredient-list">
                            {displayText}
                          </Typography>
                        </li>
                      )
                    })
                ) : (
                  <li>
                    <Typography className="mobile-preview__ingredient-list">
                      {item?.value}
                    </Typography>
                  </li>
                )}
              </ul>
            ) : (
              <Typography
                variant="body2Regular"
                className="mobile-preview__ingredient-list"
                style={{ marginTop: 5 }}>
                {typeof item?.value === "string" || typeof item?.value === "number"
                  ? item?.value
                  : Array.isArray(item?.value)
                  ? item?.value
                      .map((val) =>
                        typeof val === "string"
                          ? val
                          : typeof val === "number"
                          ? val
                          : val?.name || val?.fact || val?.measurement || ""
                      )
                      .filter(Boolean)
                      .join(", ")
                  : ""}
              </Typography>
            )}

            {index !== validItems.length - 1 && (
              <Divider className="mobile-preview__ingredient-divider" />
            )}
          </div>
        ))}
      </Box>
    </div>
  )
}

export default Details
